import { render, staticRenderFns } from "./deviceBox.vue?vue&type=template&id=98dce0d4&scoped=true"
import script from "./deviceBox.vue?vue&type=script&lang=js"
export * from "./deviceBox.vue?vue&type=script&lang=js"
import style0 from "./deviceBox.vue?vue&type=style&index=0&id=98dce0d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dce0d4",
  null
  
)

export default component.exports